export const Heading = {
  sizes: {
    '4xl': {
      fontSize: ['5xl', null, '6xl'],
      lineHeight: 1
    },
    '3xl': {
      fontSize: ['4xl', null, '5xl'],
      lineHeight: 1
    },
    '2xl': {
      fontSize: ['3xl', null, '4xl'],
      lineHeight: [1.33, null, 1]
    },
    xl: {
      fontSize: ['2xl', null, '3xl'],
      lineHeight: 1.33
    },
    lg: {
      fontSize: ['xl', null, '2xl'],
      lineHeight: 1.33
    },
    md: {
      fontSize: 'lg',
      lineHeight: 1.33
    },
    sm: {
      fontSize: 'md',
      lineHeight: 1.33
    },
    xs: {
      fontSize: 'sm',
      lineHeight: 1.33
    }
  },
  baseStyle: {
    fontFamily: 'heading',
    fontWeight: 'bold'
  },
  defaultProps: {
    size: 'md'
  }
}
